import { useRef, useState, useEffect } from "react";
import styles from "./index.css";
import BannerContent from "./BannerContent";

import PropTypes from "prop-types";
import shouldEnableBanner from "./shouldEnableBanner";

const LoyaltyMembersDayBanner = ({
  categoryId,
  isMembersDayAvailable,
  membersDayEvent,
  storeCode
}) => {
  const bannerRef = useRef(null);

  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(
      shouldEnableBanner({
        categoryId,
        isMembersDayAvailable,
        membersDayEvent,
        storeCode
      })
    );
  }, [isMembersDayAvailable, membersDayEvent, storeCode]);

  if (!isEnabled) {
    return null;
  }

  return (
    <div className={styles.loyaltyMembersDayBanner} ref={bannerRef}>
      <BannerContent membersDayEvent={membersDayEvent} />
    </div>
  );
};

LoyaltyMembersDayBanner.propTypes = {
  categoryId: PropTypes.number.isRequired,
  membersDayEvent: PropTypes.string,
  isMembersDayAvailable: PropTypes.bool,
  storeCode: PropTypes.string
};

export default LoyaltyMembersDayBanner;
